import React, { Fragment } from 'react';

import { AlertDescription, ButtonGroup, Link } from '@zapier/design-system';

import LinkButton from 'app/common/components/LinkButton';

type Props = {
  email: string;
  integrationId: number;
};

export default function AlertBody({ email, integrationId }: Props) {
  return (
    <Fragment>
      <AlertDescription>
        Zapier Partner Sandbox offers you premium Zapier features for free,
        designed to support the ongoing development of your integrations.{' '}
        <Link
          href="https://docs.zapier.com/platform/publish/zps"
          target="_blank"
        >
          Learn more
        </Link>
        .
      </AlertDescription>
      <ButtonGroup columnSize="minmax(0, auto)" maxWidth="165px">
        <LinkButton
          color="primary"
          href={`https://zps.zapier.app/request?app-id=${integrationId}&email=${email}`}
          target="_blank"
        >
          Request access
        </LinkButton>
      </ButtonGroup>
    </Fragment>
  );
}
